import { api } from "@monolith/helpers";

const state = {
  orders: [],
  currentPosition: false,
  geoSettings: [],
  driverPositions: [],
};

const getters = {
  orders: (state) => state.orders,
  selectedOrders: (state) => state.orders.filter((o) => o.delivery_data.status === "assigned" || o.delivery_data.status === "out_for_delivery"),
  avaliableOrders: (state) => state.orders.filter((o) => !("status" in o.delivery_data)),
  getGeoSettings: (state) => state.geoSettings,
  getDriverPositions: (state) => state.driverPositions, 
};

const actions = {
  async updateGeoSettings({ commit }) {
    const settings = await api.get_geo_settings(localStorage.getItem("company"));
    commit("setGeoSettingsMutation", settings);
  },

  updateDriverPosition({ commit }, driver) {
    commit("updateDriverPosition", driver);
  },

  updateOrders({ commit }, payload) {
    commit("setOrders", payload);
  },

  addOrderToOrders({ commit }, order) {
    commit("addOrder", order);
  },

  addToSelectedOrders({ commit }, order) {
    commit("setSelectedOrders", order);
  },

  statusChange({ commit }, order) {
    commit("updateOrderStatus", order);
  },
};

const mutations = {
  updateDriverPosition(state, driver) {
    const index = state.driverPositions.findIndex((d) => d.id === driver.id);
    if (index !== -1) {
      state.driverPositions[index] = driver;
    } else {
      state.driverPositions.push(driver);
    }
  },

  setOrders(state, orders) {
    state.orders = orders;
  },

  addOrder(state, order) {
    state.orders.push(order);
  },

  updateOrderStatus(state, order) {
    state.orders.forEach((o) => {
      if (o._id === order._id) {
        o = order;
      }
    });
  },

  setGeoSettingsMutation(state, settings) {
    state.geoSettings = settings;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
